import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
const IS_PRODUCTION = process.env.REACT_APP_MODE === 'production';

// ✅ Proper boolean parsing
const isMixpanelDisabled = () =>
  Cookies.get("IS_MIXPANEL_DISABLED") === "true" ||
  process.env.REACT_APP_IS_MIXPANEL_DISABLED === "true";

// ✅ Centralized enable check
const isMixpanelEnabled = () =>
  !!MIXPANEL_TOKEN && !isMixpanelDisabled();

// ✅ Init
if (isMixpanelEnabled()) {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: !IS_PRODUCTION,
    track_pageview: false,
    persistence: 'localStorage',
  });
}

/**
 * Reads utm_campaign and utm_source from cookies first,
 * then falls back to the current URL search params.
 */
export const getUtmProperties = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_campaign:
      Cookies.get('utm_campaign') ||
      params.get('utm_campaign') ||
      undefined,
    utm_source:
      Cookies.get('utm_source') ||
      params.get('utm_source') ||
      undefined,
  };
};

const MixpanelService = {
  identify(userId) {
    if (!isMixpanelEnabled()) return;
    mixpanel.identify(userId);
  },

  setProfile(properties) {
    if (!isMixpanelEnabled()) return;
    mixpanel.people.set(properties);
  },

  track(eventName, properties = {}) {
    if (!isMixpanelEnabled()) return;
    mixpanel.track(eventName, properties);
  },

  reset() {
    if (!isMixpanelEnabled()) return;
    mixpanel.reset();
  },
};

export default MixpanelService;